import React from "react";

import config from "../../dashboard-config";

import MapImageLayer from "../Mapping/MapImageLayer";
import MapboxContainer from "../Mapping/MapboxContainer";

import useSofarForecastPNG from "./useSofarForecastPNG";

const MapPlayground: React.FC<{}> = () => {
  const { status: forecastStatus, data: forecastData } = useSofarForecastPNG({
    bounds: {
      minLongitude: 0,
      maxLongitude: 360,
      minLatitude: -89,
      maxLatitude: 89
    },
    dataSourceId: 2,
    variableId: 50,
    colorScale: defaultColorScale,
    timestamp: "2020-04-10T01:11:16.172Z"
  });

  return (
    <MapboxContainer
      token={config.mapboxToken ?? ""}
      styleUrl={config.mapboxStyleUrl ?? ""}
      width={"100vw"}
      height={"100vh"}
    >
      {forecastStatus === "ready" && forecastData && (
        <MapImageLayer
          source={forecastData.pngDataUrl}
          id="Forecast"
          corners={forecastData.corners}
        />
      )}
    </MapboxContainer>
  );
};

const defaultColorScale = [
  { pixelValue: 40, red: 124, green: 1, blue: 1, alpha: 128 },
  { pixelValue: 30, red: 239, green: 0, blue: 0, alpha: 128 },
  { pixelValue: 25, red: 255, green: 80, blue: 0, alpha: 128 },
  { pixelValue: 20, red: 255, green: 255, blue: 0, alpha: 128 },
  { pixelValue: 15, red: 128, green: 255, blue: 128, alpha: 128 },
  { pixelValue: 12, red: 16, green: 255, blue: 239, alpha: 128 },
  { pixelValue: 10, red: 0, green: 159, blue: 255, alpha: 128 },
  { pixelValue: 5, red: 0, green: 30, blue: 255, alpha: 128 },
  { pixelValue: 0, red: 0, green: 0, blue: 143, alpha: 128 }
];

export default MapPlayground;
